/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { ConsumerAppConfigContext, defaultAppConfig } from '../../contexts/appConfig';
import { getConfig } from '@utils/configs';

export namespace AppConfigProvider {
  export interface Props {}
}

export const ConsumerAppConfigProvider: React.FC<AppConfigProvider.Props> = ({ children }) => {
  const { colors } = getConfig();
  // extends themedColors with colors from backend
  const appConfig = { ...defaultAppConfig, colors: { ...defaultAppConfig.colors, ...colors } };
  return (
    <ConsumerAppConfigContext.Provider value={appConfig} data-it="AppConfig">
      {children}
    </ConsumerAppConfigContext.Provider>
  );
};
